import React from 'react';
import AuditReportsPage from './AuditReportsPage';
import Backend from '../../../Layouts/Backend';
import Loading from '../../../Helpers/Loading';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../../actions/report.actions';
import helper from '../../../../utils/helper';
import lookupActions from '../../../../actions/lookup.actions';
import auditApi from '../../../../api/auditApi';
import { debounce } from 'lodash-es';

class AuditReports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isFetching: false,
      departments: [],
      totalRecords: 0,
      page: 1,
      size: 25,
      runOnce: false,
      auditReports: [],
      errors: [],
      sortedCol: null,
      order: null,
      fromDate: new Date(),
      toDate: new Date(),
      departmentId: null,
      searchText: '',
    };
    this.columns = [
      {
        dataField: 'time',
        text: 'Time',
        sort: true,
        isDateTime: true,
        headerStyle: { width: 150 },
        onSort: this.onSort,
      },
      {
        dataField: 'modifiedBy',
        text: 'Modified By',
        sort: true,
        onSort: this.onSort,
      },
      {
        dataField: 'field',
        text: 'Field',
        sort: true,
        onSort: this.onSort,
      },
      {
        dataField: 'previous',
        text: 'Previous',
        sort: true,
        onSort: this.onSort,
      },
      {
        dataField: 'new',
        text: 'New',
        sort: true,
        onSort: this.onSort,
      },
      {
        dataField: 'description',
        text: 'Description',
        sort: true,
        onSort: this.onSort,
      },
    ];
    this.searchData = debounce(this.searchData, 300);
  }

  onSort = (field, order) => {
    this.setState({
      sortedCol: field,
      order,
    });
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.lookup.departments !== prevState.departments) {
      state.departments = nextProps.lookup.departments;
    }
    // if (nextProps.report.auditReports !== prevState.auditReports) {
    //   state.auditReports = nextProps.report.auditReports;
    // }
    if (nextProps.report.isFetching !== prevState.isFetching) {
      state.isFetching = nextProps.report.isFetching;
    }
    state.errors = helper.centralizeError([
      nextProps.lookup.errors,
      nextProps.report.error,
    ]);
    return Object.keys(state).length ? state : null;
  }

  componentDidMount() {
    this.setState({ loading: true }, async () => {
      await this.props.reportActions.clearReport();
      await this.props.lookupActions.getDepartments();
      // const { page, size } = helper.parseQueryString(
      //   this.props.location.search,
      // );
      // if (!(page && size)) {
      //   this.setState({ page: page ? page : 1, size: size ? size : 25 });
      //   // this.props.history.replace(
      //   //   `/reports/audit-reports?page=${page ? page : 1}&size=${
      //   //     size ? size : 25
      //   //   }`,
      //   // );
      // }
    });
    this.setState({ loading: false });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.runOnce) {
      if (
        this.state.page !== prevState.page ||
        this.state.size !== prevState.size
      ) {
        this.props.reportActions
          .getAuditReports(
            this.state.fromDate,
            this.state.toDate,
            this.state.departmentId,
            (this.state.page - 1) * this.state.size,
            this.state.size,
            this.state.searchText,
          )
          .then((resp) =>
            this.setState({
              totalRecords: resp.totalCount,
              auditReports: resp.items,
              runOnce: true,
            }),
          )
          .catch((err) => console.log(err));
      }
    }
  }

  handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, data },
  ) => {
    setTimeout(() => {
      let result;
      if (sortOrder === 'asc') {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
      this.setState(() => ({
        auditReports: result,
        page: page,
        size: sizePerPage,
      }));
    }, 500);
    // this.setState({ page: page, size: sizePerPage });
  };

  onFilter = (values) => {
    this.props.reportActions
      .getAuditReports(
        values.fromDate,
        values.toDate,
        values.departmentId,
        0,
        25,
      )
      .then((resp) =>
        this.setState({
          totalRecords: resp.totalCount,
          auditReports: resp.items,
          runOnce: true,
          fromDate: values.fromDate,
          toDate: values.toDate,
          departmentId: values.departmentId,
          searchText: '',
        }),
      )
      .catch((err) => console.log(err));
  };
  onSearch = (keyword) => {
    this.setState({ searchText: keyword }, () => {
      if (this.state.runOnce) {
        this.searchData(keyword);
      }
    });
  };
  searchData = (keyword) => {
    this.props.reportActions
      .getAuditReports(
        this.state.fromDate,
        this.state.toDate,
        this.state.departmentId,
        (this.state.page - 1) * this.state.size,
        this.state.size,
        keyword,
      )
      .then((resp) =>
        this.setState({
          totalRecords: resp.totalCount,
          auditReports: resp.items,
          runOnce: true,
        }),
      )
      .catch((err) => console.log(err));
  };
  onExportAudit = (format, params) => {
    auditApi.exportAudit(format, {
      ...params,
      Keyword: this.state.searchText,
      Sorting: `${this.state.sortedCol}=${this.state.order}`,
    });
  };
  render() {
    //prettier-ignore
    const { loading, isFetching, errors, departments, auditReports, page, size } = this.state;
    if (loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    const { deptId, deptName } = helper.getUserDepartment(departments);
    return (
      <AuditReportsPage
        isFetching={isFetching}
        errors={errors}
        departments={departments}
        initDeptId={deptId}
        initDeptName={deptName}
        totalRecords={this.state.totalRecords}
        auditReports={auditReports}
        page={page}
        size={size}
        onTableChange={this.handleTableChange}
        onFilter={this.onFilter}
        searchText={this.state.searchText}
        onSearch={this.onSearch}
        datagridProps={{
          columns: this.columns,
          defaultSorted: this.defaultSorted,
        }}
        onExportAudit={this.onExportAudit}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    lookup: state.lookup,
    report: state.report,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
    reportActions: bindActionCreators(
      Object.assign({}, reportActions),
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AuditReports);
